import { getAttribute, KnownAttributes } from 'domain/experiment/attribute';

import { Entity } from '../entity-model';

import { EntitiesLists } from './list-for-runs-model';

export const filterArchived = (list: EntitiesLists): EntitiesLists => {
  const filteredList: EntitiesLists = {
    experiments: [],
    runs: [],
  };
  list.experiments.forEach((experiment) => {
    if (getAttribute(experiment.attributes, KnownAttributes.Archived, 'bool')?.value === false) {
      filteredList.experiments.push(experiment);
    }
  });
  list.runs.forEach((run) => {
    if (getAttribute(run.attributes, KnownAttributes.Archived, 'bool')?.value === false) {
      filteredList.runs.push(run);
    }
  });
  return filteredList;
};

export const mergeEntitiesByUUID = (list: EntitiesLists): Entity[] => {
  const mergedList = new Map<string, Entity>();

  list.runs.forEach((run) => {
    mergedList.set(run.id, run);
  });
  list.experiments.forEach((experiment) => {
    mergedList.set(experiment.id, experiment);
  });

  return Array.from(mergedList.values());
};
